import ServiciosCarousel from './ServiciosCarousel';
import ModalRequest from './ModalRequest'
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../App.css'; 
import { Helmet } from 'react-helmet-async';
import fabrica from '../assets/seccion servicios/FABRICA-2.jpg'
import mochila from '../assets/seccion servicios/mochila.jpg'
import corp3 from "../assets/seccion servicios/Seguridad corpo 3.jpg"
import controlacc from '../assets/seccion servicios/molinete electron.jpg'
import seguridad from '../assets/seccion servicios/camaras.jpeg'
import auto from '../assets/seccion servicios/handyauto.jpg'
import barrio from '../assets/seccion servicios/residencial2.jpg'
import barrio2 from '../assets/seccion servicios/residencial 3.jpg'
import barrio4 from '../assets/seccion servicios/Seg Barrios/Guardias y vigilancia para condominios.jpg'
import barrio5 from '../assets/seccion servicios/Seg Barrios/Seguridad privada para barrios y condominios.jpg'
import barrio6 from '../assets/seccion servicios/Seg Barrios/Seguridad y guardias para barrios privados.jpg'
import edificio1 from '../assets/seccion servicios/Seg Edificios/Seguridad privada para administraciones.jpg'
import edificio2 from '../assets/seccion servicios/Seg Edificios/Guardias de seguridad privada para edificios y consorcios.jpg'
import edificio3 from '../assets/seccion servicios/Seg Edificios/Seguridad privada para consorcios.jpg'
import edificio4 from '../assets/seccion servicios/Seg Edificios/Seguridad privada para edificios.jpeg'
import guardiasempresa4 from '../assets/seccion servicios/Seg Empresas/Guardias de seguridad para empresas.jpg'
import guardiasempresa5 from '../assets/seccion servicios/Seg Empresas/Guardias y vigilancia para empresas.jpg'
import guardiasempresa6 from '../assets/seccion servicios/Seg Empresas/Seguridad privada para industrias.jpg'
import telefono from '../assets/seccion servicios/lucas telefono oficina.jpg'
import trato from '../assets/seccion servicios/MANOS 1.jpg'
import monitoreo from '../assets/seccion servicios/MONITOREO LUCAS HANDY.jpg'
import empresaDeSeguridad from '../assets/seccion servicios/empresa seguridad privada seguridad electronica.jpg'
import seguridadElectronica from '../assets/seccion servicios/seguridad electronica planificacion.jpg'
import guardiaEdificio from '../assets/seccion servicios/guardia edificio.jpg'



const Servicios = () => {
  const Escudo = () => (
    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 512 512" className='escudo'>
      <path d="M256-.0078C260.7-.0081 265.2 1.008 269.4 2.913L457.7 82.79C479.7 92.12 496.2 113.8 496 139.1C495.5 239.2 454.7 420.7 282.4 503.2C265.7 511.1 246.3 511.1 229.6 503.2C57.25 420.7 16.49 239.2 15.1 139.1C15.87 113.8 32.32 92.12 54.3 82.79L242.7 2.913C246.8 1.008 251.4-.0081 256-.0078V-.0078zM256 444.8C393.1 378 431.1 230.1 432 141.4L256 66.77L256 444.8z"></path></svg>
  );


  const empresas = [
    { id: 1, src:fabrica, alt: "Imagen 1" },
    { id: 2, src:mochila, alt: "Imagen 2" },
    { id: 3, src:corp3, alt: "Imagen 3" },
    { id: 4, src:guardiasempresa4, alt: "Guardias de seguridad para empresas" },
    { id: 5, src:guardiasempresa5, alt: "Guardias y vigilancia para empresas" },
    { id: 6, src:guardiasempresa6, alt: "Seguridad privada para industrias" },
  ];

  ////////////////
  const residencial = [
    { id: 1, src:auto, alt: "Imagen 1" },
    { id: 2, src:barrio, alt: "Imagen 2" },
    { id: 3, src:barrio2, alt: "Imagen 3" },
    { id: 4, src:barrio4, alt: "Guardias y vigilancia para condominios" },
    { id: 5, src:barrio5, alt: "Seguridad privada para barrios y condominios" },
    { id: 6, src:barrio6, alt: "Seguridad y guardias para barrios privados" },
  ];

  ///////////////////////////
  const edificios = [
    { id: 1, src:edificio1, alt: "Seguridad privada para administraciones" },
    { id: 2, src:edificio2, alt: "Guardias de seguridad privada para edificios y consorcios" },
    { id: 3, src:edificio3, alt: "Seguridad privada para consorcios" },
    { id: 4, src:edificio4, alt: "Seguridad privada para consorcios" },
    { id: 5, src:guardiaEdificio, alt: "Guardia edificio" },
  ];

  ///////////////////////////
  const dispos = [
    { id: 1, src:controlacc, alt: "Imagen 1"},
    { id: 2, src:seguridad, alt: "Imagen 2"},
    { id: 3, src:seguridadElectronica, alt: "empresa seguridad privada seguridad electronica"},
    { id: 4, src:empresaDeSeguridad, alt: "seguridad electronica planificacion"}
  ];

///////////////////////


  const IconoFlecha = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      className="icono-flecha"
    >
      <path d="M246.6 233.4l-160-160c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L178.8 256l-137.4 137.4c-12.5 12.5-12.5 32.75 0 45.25C47.63 444.9 55.81 448 64 448s16.38-3.125 22.62-9.375l160-160C259.1 266.1 259.1 245.9 246.6 233.4zM438.6 233.4l-160-160c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L370.8 256l-137.4 137.4c-12.5 12.5-12.5 32.75 0 45.25C239.6 444.9 247.8 448 256 448s16.38-3.125 22.62-9.375l160-160C451.1 266.1 451.1 245.9 438.6 233.4z"></path>
    </svg>
  );

///////////////////////////////////


  return (
    <>
      <Helmet>
          <title>Servicios de Seguridad Privada en Buenos Aires | Armat03</title>
          <meta name="description" content="Servicios de seguridad privada para empresas, industrias, barrios y consorcios. Vigilancia, control de accesos y supervisión en Buenos Aires." />
      </Helmet>

    <div  className="company-info-section ">
      <div className="header-section-servicios">
      </div>
      
      <div className="py-5 company-info-section mx-4">
        <h2 className="text-center mb-5 ">SERVICIOS DE SEGURIDAD</h2>
        <p  className="description text-justify-custom">
          Nos especializamos en el servicio de guardias de seguridad privada y vigilancia. Buscamos superar expectativas de nuestros clientes con servicios excepcionales y relaciones comerciales sólidas y duraderas, aspirando a la excelencia en nuestro trabajo
        </p>

        <div id="empresas" className='section-servicio'></div>
        <div >
          <hr className="divider2 my-5" />
        </div>

        <Row className="align-items-start">
          <Col md={4}>
            <ServiciosCarousel images={empresas} interval={2000} className="" />
          </Col>

          <Col className="" md={8}>
            <h1>Servicios de seguridad para empresas</h1>
            <p className="description text-justify-custom alineamientoem"> 
              Ofrecemos servicios para empresas, brindando soluciones de vigilancia y seguridad a corporaciones como fábricas, laboratorios y todo tipo de organizaciones. Nuestro objetivo es desarrollar un plan de seguridad a medida, con guardias de seguridad capacitados y un equipo responsable que acompañe cada operación.
            </p>
            <ul>
              <li className="description alineamientoem"><IconoFlecha />Control de acceso de personal, visitas y proveedores.</li>
              <li className="description alineamientoem"><IconoFlecha />Control de vehículos, mercadería e instalaciones.</li>
              <li className="description alineamientoem"><IconoFlecha />Monitoreo del perímetro las 24 horas.</li>
              <li className="description alineamientoem"><IconoFlecha />Rondas preventivas internas y externas.</li>
              <li className="description alineamientoem"><IconoFlecha />Elaboración de informes y novedades operativas para la toma de decisiones.</li>
            </ul>
          </Col>          
        </Row>

        <div id="barrio-cerrado" className='section-servicio'></div>
        <div >
          <hr className="divider2 my-5" />
        </div>

        <Row className="align-items-start" >
          <Col md={8} className="">
              <h1>Seguridad para barrios privados y barrios cerrados</h1>
              <p className="description text-justify-custom alineamientoba">
                Brindamos servicios de seguridad privada orientados a barrios privados, barrios cerrados, condominios y edificios, desarrollando soluciones de vigilancia y seguridad a medida de cada entorno. Nuestro enfoque está puesto en la protección de personas y bienes, con planificación, presencia y control operativo permanente. 
              </p>
              <ul>
                <li className="description alineamientoba"><IconoFlecha />Personal de guardias de seguridad privada capacitado y equipado según el objetivo.</li>
                <li className="description alineamientoba"><IconoFlecha />Móviles de recorrido y rondas preventivas.</li>
                <li className="description alineamientoba"><IconoFlecha />Monitoreo permanente del perímetro.</li>
                <li className="description alineamientoba"><IconoFlecha />Control de accesos de residentes, visitas y proveedores.</li>
                <li className="description alineamientoba"><IconoFlecha />Registro de novedades y reportes operativos.</li>
              </ul>
          </Col>
          <Col md={4} className="">  
            <ServiciosCarousel images={residencial} interval={2000} />
          </Col>  
        </Row>

        <div id="edificios" className='section-servicio'></div>
        <div>
          <hr className="divider2 my-5" />
        </div>

        <Row className="align-items-start">
          <Col md={4} className="image-col">
            <ServiciosCarousel images={edificios} interval={2000} />
          </Col>
          <Col className="" md={8}>
            <h1 className="">Seguridad física y vigilancia privada para edificios</h1>
            <p className="description text-justify-custom alineamientoed">
              Prestamos servicios de seguridad física y vigilancia privada para edificios, dirigidos a consorcios, edificios corporativos y residenciales. Implementamos esquemas eficientes, basados en la prevención, el control de accesos y la presencia permanente de guardias, con supervisión y seguimiento operativo.
            </p>
            <ul>
              <li className="description alineamientoed"><IconoFlecha />Vigilancia fija en accesos principales y sectores sensibles.</li>
              <li className="description alineamientoed"><IconoFlecha />Control de ingresos y egresos, personal y proveedores.</li>
              <li className="description alineamientoed"><IconoFlecha />Rondas preventivas internas y externas.</li>
              <li className="description alineamientoed"><IconoFlecha />Monitoreo del perímetro y áreas comunes.</li>
              <li className="description alineamientoed"><IconoFlecha />Registro de novedades e informes operativos para la administración.</li>
            </ul>
          </Col>
        </Row>

        <hr className="divider2 my-5"/>
        <Row className="align-items-start">
          <Col md={8} className="">
            <h1>Sistemas de seguridad electrónica</h1>
            <p className="description text-justify-custom alineamientoseg">
              Ofrecemos soluciones de seguridad electrónica como complemento a los servicios de seguridad privada y vigilancia, orientadas a reforzar el control, la prevención y la supervisión de instalaciones. Implementamos sistemas confiables y escalables, adaptados a las necesidades de cada cliente.
            </p>
            <ul>
              <li className="description alineamientoseg"><IconoFlecha />Sistemas de CCTV para monitoreo y registro de eventos.</li>
              <li className="description alineamientoseg"><IconoFlecha />Sistemas de control de accesos electrónicos.</li>
              <li className="description alineamientoseg"><IconoFlecha />Sistemas de control de acceso biométrico.</li>
              <li className="description alineamientoseg"><IconoFlecha />Integración de dispositivos de seguridad electrónica a planes de vigilancia existentes.</li>
              <li className="description alineamientoseg"><IconoFlecha />Asesoramiento en la selección e implementación de tecnología adecuada.</li>
            </ul>
          </Col>
          <Col md={4} className="">
            <ServiciosCarousel images={dispos} interval={2000} className='' />
          </Col>
        </Row>
     </div>

     <Container fluid style={{ backgroundColor: 'white' }}>
        <div className="company-info-section" style={{ backgroundColor: 'white' }}> 
          <Row className="align-items-center justify-content-center p-5 company-info-section" style={{ backgroundColor: 'white' }}>
            <Col lg={4} md={12} xs={12} sm={12} className="text-black mb-4 mb-md-0">
              <h2>POR QUÉ ELEGIRNOS</h2>
              <p className='text-justify-custom '>
                Trabajamos con un enfoque claro: entender, planificar correctamente y ejecutar con responsabilidad. Priorizamos relaciones comerciales basadas en la confianza, la presencia operativa y la continuidad del servicio, más que en promesas vacías.
              </p>
              <div className='text-center'><ModalRequest /></div>
            </Col>
            <Col lg={8} md={12} xs={12} sm={12} className="d-flex flex-wrap justify-content-center">
              <Card className="text-white card-custom m-1" >
                <div className='card-img2'>
                  <Card.Img src={telefono} alt="Soluciones" className="card-img2" />
                </div>
                <Card.ImgOverlay className="d-flex flex-column justify-content-between text-center">
                  <div className="card-content">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className='escudo'><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
                    <Card.Title>RESPUESTA OPERATIVA</Card.Title>
                    <Card.Text className='card-text text-white'>
                      Actuamos con respuesta inmediata y efectiva, a través de personal capacitado y procedimientos definidos, garantizando una intervención rápida y confiable ante cualquier requerimiento.
                    </Card.Text>
                  </div>
                  
                </Card.ImgOverlay>
              </Card>
              <Card className="text-white card-custom m-1" >
                <div className='card-img2'>
                  <Card.Img src={trato} alt="Soluciones" className="card-img2" />
                </div>
                <Card.ImgOverlay className="d-flex flex-column justify-content-between text-center">
                  <div className="card-content">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" className='escudo'><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm3.71 7.293a1 1 0 0 0 -1.415 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" /></svg>
                    <Card.Title>SOLUCIONES A MEDIDA</Card.Title>
                    <Card.Text className='card-text text-white'>
                      Desarrollamos planes de seguridad acordes a cada objetivo, brindando acompañamiento técnico y asesoramiento para una correcta toma de decisiones.
                    </Card.Text>
                  </div>
                </Card.ImgOverlay>
              </Card>
              <Card className="text-white card-custom m-1">
                <div className='card-img2'>
                  <Card.Img src={monitoreo} alt="Supervisión" className="card-img2" />
                </div>
                <Card.ImgOverlay className="d-flex flex-column justify-content-between text-center">
                  <div className="card-content">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" className='escudo'><path d="M12 4c4.29 0 7.863 2.429 10.665 7.154l.22 .379l.045 .1l.03 .083l.014 .055l.014 .082l.011 .1v.11l-.014 .111a.992 .992 0 0 1 -.026 .11l-.039 .108l-.036 .075l-.016 .03c-2.764 4.836 -6.3 7.38 -10.555 7.499l-.313 .004c-4.396 0 -8.037 -2.549 -10.868 -7.504a1 1 0 0 1 0 -.992c2.831 -4.955 6.472 -7.504 10.868 -7.504zm0 5a3 3 0 1 0 0 6a3 3 0 0 0 0 -6" /></svg>
                    <Card.Title>SUPERVISIÓN PERMANENTE</Card.Title>
                    <Card.Text className='card-text text-white'>
                      Supervisamos cada objetivo de forma continua, permitiendo al cliente contar con información clara y seguimiento real del objetivo y/o operación en ejecución
                    </Card.Text>
                  </div>
                </Card.ImgOverlay>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  </>   
  );
};

export default Servicios;
